import React, { useEffect, useState } from 'react'
import { image } from '../../../app/utils/common/image';
import { useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../../redux/store';
import { getProfile, selectAllProfile, selectProfileError, selectProfileStatus } from '../../../redux/Slices/ProfileSlice';
import { updateProfile } from '../../../redux/Slices/avatarsSlice';
import { message } from 'antd';
import BackButton from '../../atoms/BackButton/BackButton'
import Button from '../../atoms/Button/Button';
import AccountContainer from '../../molecules/AccountContainer/AccountContainer';
// AVATAR SELECTION DISABLED TEMPORARILY
// import ProfileAvatars from '../../molecules/profileAvatars/profileAvatars';
import './AccountDetailsScreen.scss'
import sendFirebaseEvent from '../../../app/firebase/sendFirebaseEvent';

const AccountDetailsScreen = () => {
    const navigate = useNavigate()
    const dispatch: AppDispatch = useDispatch();
    const profile = useSelector(selectAllProfile);
    const profileStatus = useSelector(selectProfileStatus);
    const profileError = useSelector(selectProfileError);

    const [loading, setLoading] = useState<boolean>(false);
    const [name, setName] = useState<string>(profile?.username || '');
    const [email, setEmail] = useState<string>(profile?.email || '');
    const [errorMessage, setErrorMessage] = useState('');
    // AVATAR SELECTION DISABLED TEMPORARILY - removed openAvatar, selcAvatarId, selcAvatarUrl states

    // useEffect(() => {
    //     dispatch(getProfile()); // Dispatch Get Profile action
    // }, [dispatch])

    // Profile status loading state
    useEffect(() => {
        if (profileStatus === 'loading') {
            setLoading(true);
        } else if (profileStatus === 'succeeded') {
            setLoading(false);
        } else if (profileStatus === 'failed') {
            setLoading(false);
            if (profileError?.error?.message === 'Game already completed.') {
                navigate('/profile')
            }
        }
    }, [profileStatus]);

    const handleBackButton = () => {
        navigate(-1)
    }

    const handleAddProfile = async () => {
        sendFirebaseEvent('update_profile_button', 'user_action', 'update_profile_button', "Update Profile Button Clicked")
        setLoading(true);
        try {
            // AVATAR SELECTION DISABLED TEMPORARILY - avatarId is not passed; only name/email update
            await dispatch(updateProfile({
                username: name || profile?.username,
                email: email || profile?.email,
            })).unwrap();
            setLoading(false);
            dispatch(getProfile());
            navigate('/profile');
            message.success('User profile updated successfully.');
        } catch (error: any) {
            message.error(error?.error?.message);
            setErrorMessage(error?.error?.message);
        }
        setLoading(false);
    }

    const handleInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        const { name: inputName, value } = e.target;
        if (inputName === 'name') {
            setName(value);
        }
        if (inputName === 'email') {
            setEmail(value);
        }
    };

    return (
        <div>
            <div className='account-heading'>
                <BackButton onClick={handleBackButton} buttonHeading='Player profile' className='heading-bckbtn-text font-bagel' />
            </div>
            {/* <div className='heading-bckbtn-acc-text font-bagel'>Account Details</div> */}
            <div className='flex login-container' style={{ height: "100vh", paddingTop: "30px" }}>
                {window.innerWidth > 750 && <img src={image.WEBLOGO} className='login-bg-img' draggable="false"
                    onContextMenu={(e) => e.preventDefault()} />}
                <div className='flex login-upper-container' style={{ gap: "10px" }}>
                    {/* AVATAR SELECTION DISABLED TEMPORARILY - avatar is auto-assigned; display only */}
                    <img
                        src={profile?.profile_image || image.INVESTORAVATAR}
                        className="account-profile"
                        draggable="false"
                        onContextMenu={(e) => e.preventDefault()}
                    />
                    <AccountContainer profile={profile} loading={loading} handleInputChange={handleInputChange} name={name} email={email} />
                    <div className='updateProfile-btn'>
                        <Button onClick={handleAddProfile} buttonTitle='Update Info' width='200px' />
                    </div>
                </div>

            </div>
            {/* AVATAR SELECTION DISABLED TEMPORARILY */}
            {/* <ProfileAvatars openAvatar={openAvatar} setOpenAvatar={setOpenAvatar} loading={loading} handleAvatar={handleAvatar} /> */}

        </div>
    )
}

export default AccountDetailsScreen